import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiIconButton, { ButtonProps } from "@mui/material/Button";

const StyledIconButton = styled(MuiIconButton)(() => ({
  "&.MuiButton-root": {
    "& .MuiSvgIcon-root": {
      fontSize: 24,
    },
  },
}));

const Button: FC<ButtonProps> = (props) => {
  return (
    <StyledIconButton
      disableElevation
      disableRipple
      disableTouchRipple
      {...props}
    />
  );
};

export default Button;
